

module.exports = {
  get Alert() { return require("./Alert/Alert.js") },
  get Animated() { return require("./Animated/Animated.js") },
  get PanResponder() { return require("./PanResponder/PanResponder.js") },
  get inject_responder_event() { return require("./PanResponder/injectResponderEventPlugin.js").inject_responder_event},
  get Swiper() { return  require("./Swiper/Swiper.js").default },
  get View() { return  require("./View/View.js").default },
}
  